import { Field } from 'formik';
import React from 'react';
const CheckBox = ({
  label,
  name,
  isRequired,
  checked,
  defaultValue,
  handleChange,
  errormsg,
  fieldFlag,
  disabled,
}) => {
  return (
    <div className="input-container2">
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <Field
        type="checkbox"
        name={name}
        disabled={disabled}
        checked={
          checked !== undefined ? checked : defaultValue !== undefined ? defaultValue : false
        }
        onChange={(e) => handleChange(e, fieldFlag)}
      />
      {errormsg && <div className="error-message">{errormsg}</div>}
    </div>
  );
};

export default CheckBox;
